import { $, $$ } from './utils'

const _showHideIf = (item, condition = true) => {
  condition ? item.classList.remove('hidden') : item.classList.add('hidden')
}

const _showHideNotFoundNotice = (wrapper, condition = false) => {
  _showHideIf($('.items-unavailable', wrapper.nextElementSibling), condition)
}

const _getDisplayedItems = (listingId) => {
  const list = $(`[data-listing-id="${listingId}"]`)
  return $$('li[data-id]', list)
}

const _removeFilteredAttribute = (wrapper) => wrapper.removeAttribute('data-filters')

const _hideFilterWrappers = () => $$('.filters-wrapper').forEach((wrapper) => wrapper.classList.add('hidden'))

const _focusExpandFiltersButton = (wrapper) => $('.expand-filters', wrapper).focus()

const _filterItems = async (params) => {
  return fetch(SpinokoFrontEnd.ajaxUrl, {
    // eslint-disable-line
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
    body: params,
  })
    .then((response) => response.json())
    .catch((error) => console.log(error))
}

const _resetListItems = (wrapper) => {
  const items = _getDisplayedItems(wrapper.dataset.id)
  if (items) {
    items.forEach((item) => _showHideIf(item))
    // if it was a limited table/grid, adjust the number of visible items
    const limit = _getLoadedLimit(wrapper)
    if (limit !== 0) {
      Array.from(items)
        .slice(limit)
        .forEach((item) => _setLoadedValue(item, 'false'))
    }
  }
  _showHideNotFoundNotice(wrapper)
}

const _getLoadedLimit = (wrapper) => parseInt(wrapper.dataset.limit || 0)

const _setLoadedValue = (item, value) => {
  item.dataset.loaded = value
}

export const toggleFilters = (button) => {
  button.closest('.listing-tools').querySelector('.filters-wrapper').classList.toggle('hidden')
}

export const filterListing = async (el) => {
  // get the wrapper and values
  const wrapper = el.closest('.listing-tools')
  const items = wrapper.dataset.items
  const value = el.value
  const filterBy = el.closest('[data-filter-block]').dataset.filterBlock

  // set filters value
  const filters = wrapper.dataset.filters ? JSON.parse(wrapper.dataset.filters) : {}
  filters[filterBy] = el.checked ? value : null
  wrapper.dataset.filters = JSON.stringify(filters)
  Object.keys(filters).every((key) => !filters[key]) && _removeFilteredAttribute(wrapper)

  // filter items (AJAX)
  const params = new URLSearchParams()
  params.append('action', `filter-${wrapper.dataset.listing}`)
  params.append('items', items)
  params.append('filters', JSON.stringify(filters))

  const filteredCasinoIds = await _filterItems(params)

  // show/hide items
  const displayedItems = _getDisplayedItems(wrapper.dataset.id)

  if (displayedItems) {
    displayedItems.forEach((item) => _showHideIf(item, filteredCasinoIds.includes(item.dataset.id)))
    // if it was a limited table/grid, adjust the number of visible items
    const limit = _getLoadedLimit(wrapper)
    if (limit !== 0) {
      Array.from(displayedItems)
        .filter((item) => !item.classList.contains('hidden'))
        .slice(0, limit)
        .forEach((item) => _setLoadedValue(item, 'true'))
    }
  }

  _showHideNotFoundNotice(wrapper, !$$('li:not(.hidden)', wrapper.nextElementSibling).length)
  _hideFilterWrappers()
  _focusExpandFiltersButton()

  // show/hide filter checkboxes
  $$(`div[data-filter-block="${filterBy}"] label`, wrapper).forEach((label) => {
    const condition = el.checked ? label.dataset.value === value : true
    _showHideIf(label, condition)
  })
}

export const searchFilters = (field) => {
  const parent = field.closest('[data-filter-block]')
  const items = $$('label', parent)
  if (items) {
    items.forEach((item) => {
      const text = $$('span', item)[0].innerText.toLowerCase()
      _showHideIf(item, text.includes(field.value.toLowerCase()))
      _showHideIf($('[data-filter-none]', parent), !$$('label:not(.hidden)', parent).length)
    })
  }
}

export const removeFilters = (button) => {
  const wrapper = button.closest('.listing-tools')
  _removeFilteredAttribute(wrapper)
  _resetListItems(wrapper)
  $$('div[data-filter-block] label', wrapper).forEach((label) => _showHideIf(label))
  $$('div[data-filter-block] label input', wrapper).forEach((input) => {
    input.checked = false
  })
  _hideFilterWrappers()
  _focusExpandFiltersButton(wrapper)
}
